import React, { Component, useCallback } from "react";
import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Row,
//   Col,
//   Badge,
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Input,
//   Dropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
// } from "reactstrap";

// import Switch from "react-bootstrap-switch";
import Form from "react-bootstrap/Form";

// import ShowHistory from "views/ShowHistory.jsx";
// import ShowHistoryData from "views/ShowHistoryData.jsx";
// import ChromeCheck from "views/ChromeCheck.jsx";
// import QuestionComment from "views/QuestionComment.jsx";
// import UserNotes from "views/UserNotes.jsx";
// import ReactHtmlParser from "react-html-parser";
import API, { s3base } from "api.js";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import { setUser, expVidPopup } from "action/index.js";
import { connect } from "react-redux";
// import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
// import ReactPlayer from "react-player";
import TokenFinished from "components/PracticeMaterial/PopUps/TokensFinished";
import ExplanationPopUp from "components/PracticeMaterial/PopUps/ExplanationPopUp";
import SampleIcon from "../assets/images/images_new/sample_response.svg";
import TooltipItem from "components/ToolTip/ToolTipItem.jsx";
// import SpeakingResult from "components/Result/SpeakingResult.jsx";
// import WritingResult from "components/Result/WritingResult.jsx";
// import ReadingResult from "components/Result/ReadingResult.jsx";
// import ListeningResult from "components/Result/ListeningResult.jsx";

import LoaderDumb from "components/Loader/LoaderDumb.jsx";
import ExplanationVidPopUp from "components/PracticeMaterial/PopUps/ExplanationVidPopup";
import ModalSkeleton from "components/PopUps/ModalSkeleton";
// import SelectOption from "components/PracticeMaterial/SelectOption";
import WordDefinitionModal from "components/PracticeMaterial/PopUps/WordDefinitionModal";
import TranslateModal from "components/PracticeMaterial/PopUps/TranslateModal";
import ListenAudio from "components/PracticeMaterial/PopUps/ListenAudio";

import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
// import VideoImg from "assets/images/images_new/user-img.png";
import TranslateIcon from "../assets/images/images_new/translate.svg";
import ExplanationIcon from "../assets/images/images_new/explanation.svg";
import MoreAiSuggestions from "components/Result/More/MoreAiSuggestions";
// import ItemNumber from "components/PracticeMaterial/New/ItemNumber";

import "cooltipz-css";

import Result from "components/Question/Result/Result";
import QuestionResponses from "components/PracticeMaterial/QuestionResponses/QuestionResponses.jsx";
import ResultPopup from "components/Question/Result/ResultPopup";
import ConfirmAction from "components/Dashboard/Popup/ConfirmAction";
import PracticePageHeader from "components/PracticeMaterial/New/PracticePageHeader";
import QuestionAudioAlternative from "components/Question/QuestionAudioAlternative";

// import TemplateDetectorModal from "components/PracticeMaterial/PopUps/TemplateDetectorModal";
import TestedPopup from "components/PracticeMaterial/PopUps/Tested";
import ReportPopup from "components/PracticeMaterial/PopUps/Report";
import LoadQuestionType from "components/PracticeMaterial/LoadQuestionType";

import QuestionInstructions from "Datasets/QuestionInstructions.json";
import FillInTheBlankExplanation from "components/PracticeMaterial/PopUps/FillInTheBlankExplanation";
import QuestionExplanationVideo from "components/PopUps/QuestionExplanationVideo";
import Spinner from "components/Loader/Spinner";
import InfiniteQuestionDropdown from "./InfiniteQuestionDropdown";
import PracticeQuestionFeaturesTour from "components/WebsiteTour/PracticeQuestionFeaturesTour";
import { cleanupAllTours } from "components/WebsiteTour/tourData";

const mapStateToProps = (state) => {
  return {
    user: state.user,
    expVidPopup: state.expVidPopup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (user) => dispatch(setUser(user)),
    setExpVidPopup: (count) => dispatch(expVidPopup(count)),
  };
};

const speaking = [1, 2, 3, 4, 5, 13, 21, 22];
const writing = [6, 7];
const TRANSLATE_BUTTON_SUBCATEGORIES = [1, 2, 4, 11, 13, 16];
const SAMPLE_RESPONSE_BUTTON_SUBCATEGORIES = [1, 11];
const TAGS = ["grey", "red", "green", "yellow"];
const SHOW_RESULT_POPUP = [1, 2, 3, 4, 5, 6, 7, 13, 20,
  21, 22];
const AUDIO_TRANSCRIPT = [2, 4, 5, 13, 14, 15, 16, 17, 18, 19, 20, 22];

const Practice = (props) => {
  const params = useParams();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const viewParam = urlParams.get("view");
  const pageParam = urlParams.get("page");
  const itemNumberParam = urlParams.get("item_number");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [startFeaturesTour, setStartFeaturesTour] = useState(false);
  const [state, setState] = useState({
    questionData: [],
    currentQuestion: 0,
    isRecording: false,
    blobURL: "",
    // error: "",
    history: [],
    board: [],
    historyData: [],
    history_flag: false,
    isBlocked: false,
    is_answer: false,
    is_result: false,
    resultObj: {
      text_answer: "",
      length: 0,
      type: params.id,
      answer: "",
      script: "",
      q_ans: "",
      correct: "",
      strategy: 1,
    },
    resultData: "",
    process: false,
    testModal: false,
    textAr: false,
    comment_process: false,
    modal: false,
    switched: false,
    reportText: "",
    history_process: false,
    historyMore: false,
    boardMore: false,
    restart: false,
    type: params.id,
    prediction: params.type,
    aType: params.aType,
    mark: params.mark,
    atmptd: params.attempted,
    complexity: params.complexity,
    filterByVid: params.videos,
    submitFlag: false,
    attempted: 0,
    intervalId1: "",
    secondCount1: 0,
    note_flag: false,
    board_process: false,
    all_ok: true,
    hideNav: parseInt(viewParam) === 1 ? true : false,
    user: props.user,
    isSubscribed: props.user.active_subscription.length > 0 ? true : false,
    viewVideo: false,
    viewHindiVideo: false,
    videoModal: false,
    videoModalState: false,
    videoHindiModal: false,
    videoHindiModalState: false,
    videoUrl: "",
    videoHindiUrl: "",
    thirtyDaysInMs: "",
    timeDiffInMs: "",
    attemptedQuestions: [],
    isAttempted: false,
    attemptedTimes: 0,
    orderby: localStorage.getItem("orderby")
      ? localStorage.getItem("orderby")
      : "desc",
    isSubscribedCheck: props.subscribed ? props.subscribed : "false",
    total_questions: 0,
    open_ques: parseInt(pageParam) ? parseInt(pageParam) : 0,
    search_string: urlParams.get("search") || "",
    user_text: null,
    connected: true,
    backOnline: false,
    ping_server: null,
    fail: undefined,
    new_html: null,
    average_pace: undefined,
    new_result: null,
    tokens: [],
    currTokens: null,
    tokensPopUp: false,
    explanationPopUp: false,
    expVid: null,
    loader: false,
    nextBtnVid: false,
    showBottomExplanationPopup: false,
    scriptLanguages: [],
    currentScriptLanguage: "English",
    audio_script: "",
    voices: [],
    modalDestroy: true,
    wordDefinitionModalIsOpen: false,
    selectedWord: "",
    shadowingPopup: false,
    translateModal: false,
    sampleResponseModal: false,
    dropdownOpen: false,
    resultPopup: false,
    confirmRestart: false,
    playingAudioFromTrascriptButton: false,
    questionAudioUrl: null,
    commonPopupIsOpen: false,
    template_issue: null,
    score_data: [],
    score: 0,
    common_sentence: null,
    template_type: null,
    paragraphExplainationModal: false,
    option_explaination: "",
    comment: [],
    confirmRestartProcessing: false,
    html: null, // Add if used in resets
    fallback_response: false, // Added missing state property
    board_flag: false,
    comment_flag: false,
    content_score: 0, // Added for afterSubmitResponseActionOne
    fluency_score: 0, // Added for afterSubmitResponseActionOne
    pronunciation_score: 0, // Added for afterSubmitResponseActionOne
    intonation_score: 0, // Added for afterSubmitResponseActionOne
    total_score: 0, // Added for afterSubmitResponseActionOne
    resultPopupData: {}, // Added for afterSubmitResponseActionOne
    allData: {}, // Added for afterSubmitResponseActionOne
    explanationModal: false, // Added for afterSubmitResponseActionOne
    loading: true, // NEW: Added for initial loading state
    error: null, // NEW: Added for error state
    mainAudioPlaying: true,
    soundStatusMain: true,
    isStopped: false,
    prevButtonLoading: false, // Loading state for previous button
    nextButtonLoading: false,  // Loading state for next button
    refreshHistory: false,
    isNavigatingToNextQue: false,
    retryError: false,
    retryMessage: "",
    retryIndex: null,
    retryType: null,
    speed_percentage:null
  });

  // const updateState = useCallback((newState) => {
  //   console.log("updateState");

  //   setState((prevState) => ({ ...prevState, ...newState }));
  // }, []);

  const FORCE_NEXT_ERROR = true;
  const autoOpenVideoTimeoutRef = React.useRef(null);
  const updateState = useCallback((updater) => {
    if (typeof updater === "function") {
      setState((prevState) => {
        const result = updater(prevState);
        return { ...prevState, ...result };
      });
    } else {
      setState((prevState) => ({ ...prevState, ...updater }));
    }
  }, []);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     updateState(prev => ({
  //       secondCount1: prev.secondCount1 + 1,
  //     }));
  //   }, 1000);

  //   return () => clearInterval(interval); // cleanup previous interval
  // }, [state.currentQuestion, state.restart, updateState]);

  useEffect(() => {
    // Stop any existing timer first
    if (state.intervalId1) {
      clearInterval(state.intervalId1);
    }

    // Start timer only if not in result mode
    const id = setInterval(() => {
      updateState((prev) => ({ secondCount1: prev.secondCount1 + 1 }));
    }, 1000);

    updateState({ intervalId1: id });

    return () => clearInterval(id); // cleanup on unmount
  }, [state.currentQuestion, state.restart, updateState]);

useEffect(() => {
  return () => window.clearTimeout(autoOpenVideoTimeoutRef.current);
}, []);

  const stayConnected = useCallback(() => {
    if (import.meta.env.VITE_ENV === "production") {
      const pingInterval = setInterval(() => {
        fetch("https://la-ping.languageacademy.com.au/connected")
          .then((response) => response.json())
          .then(() => { })
          .catch(() => { });
      }, 5000);
      updateState({ ping_server: pingInterval });
    }
  }, []);

  const timer1 = useCallback(() => {
    updateState((prevState) => ({
      secondCount1: prevState.secondCount1 + 1,
    }));
  }, [updateState]);
  // const loadQuestion = useCallback(
  //   async (ques, q_id = null) => {
  //     let localStorage_orderby = localStorage.getItem("orderby");
  //     if (!localStorage_orderby) {
  //       localStorage.setItem("orderby", "desc");
  //     }

  //     let hideNav = parseInt(viewParam) === 1 ? true : false;
  //     let search_string = urlParams.get("search") || "";

  //     const {
  //       type,
  //       prediction,
  //       aType,
  //       mark,
  //       atmptd,
  //       complexity,
  //       orderby,
  //       filterByVid,
  //     } = state;

  //     try {
  //       const response = await API({
  //         method: "GET",
  //         url: `question/${type}?prediction=${prediction}&type=${aType}&mark=${mark}&attempted=${atmptd}&complexity=${complexity}&orderby=${orderby}&practice=${!hideNav}&open_ques=${ques}&qid=${q_id}&search=${search_string}&filterByVid=${filterByVid}`,
  //       });
  //       return response;
  //     } catch (error) {
  //       console.error("Error loading question:", error);
  //       return { status: 500, data: null };
  //     }
  //   },
  //   [
  //     state.type,
  //     state.prediction,
  //     state.aType,
  //     state.mark,
  //     state.atmptd,
  //     state.complexity,
  //     state.orderby,
  //     state.filterByVid,
  //     viewParam,
  //     urlParams,
  //   ]
  // );

  const loadQuestion = useCallback(
    async (ques, q_id = null) => {
      let localStorage_orderby = localStorage.getItem("orderby");
      if (!localStorage_orderby) {
        localStorage.setItem("orderby", "desc");
      }

      let hideNav = parseInt(viewParam) === 1 ? true : false;
      let search_string = urlParams.get("search") || "";
      try {
        updateState({
          retryError: false,
          retryMessage: ""
        });
        const res = await API({
          method: "GET",
          url: `question/${params.id}?prediction=${params.type}&type=${params.aType
            }&mark=${params.mark}&attempted=${params.attempted}&complexity=${params.complexity
            }&orderby=${localStorage_orderby}&practice=${!hideNav}&open_ques=${ques}&qid=${q_id}&search=${search_string}&filterByVid=${params.videos
            }`,
        });
        return res
      } catch (error) {
        console.error(error);
        updateState({
          retryError: true,
          retryMessage: "Unable to load question. Please retry."
        });
        store.dispatch(
          setAlert({
            flag: true,
            type: 2,
            message: error.response.data.status || "Unable to load question",
          })
        );
      }
    },
    [
      params.id,
      params.type,
      params.aType,
      params.mark,
      params.attempted,
      params.complexity,
      params.videos,
      viewParam,
      urlParams,
    ]
  );

  const loadQuestiondata = useCallback(async () => {
    try {
      const data = await API({
        method: "GET",
        url: "question/",
      });
      updateState({ questionData: data?.data?.data });
    } catch (error) {
      console.error("Error loading question data:", error);
    }
  }, []);

  const loadAttemptedQuestiondata = useCallback(
    (currentQuestionId) => {
      const { user_attempted_questions } = props.user;
      let attemptedQuestions = [];
      if (user_attempted_questions != null) {
        attemptedQuestions = user_attempted_questions.attempted_questions;
      }

      updateState((prevState) => {
        if (prevState.questionData.length === 0) return {};

        let question_id = prevState.questionData[0]?.id?.toString();
        const checkquestionid = attemptedQuestions.includes(question_id);
        return { isAttempted: checkquestionid };
      });
    },
    [updateState]
  );

  // console.log("(is_answer || !submitFlag ) && !isStopped",(state.is_answer || !state.submitFlag ) && !state.isStopped);


  useEffect(() => {
    updateState({
      isAttempted: state.attemptedTimes > 0 ? true : false
    });
  }, [state.attemptedTimes, state.isAttempted])

  const nextButtonVidPopup = useCallback(
    (status, showVid = false, manualClose = false) => {
      updateState({ nextBtnVid: status });
      if (!manualClose && !showVid && !status) {
        props.setExpVidPopup(10);
      }
    },
    [props.setExpVidPopup, updateState]
  );

  const changeReportText = useCallback((e) => {
    let { name, value } = e.target;
    updateState({ [name]: value });
  }, []);

  const submitReport = useCallback(async () => {
    if (state.reportText === "") {
      store.dispatch(
        setAlert({ flag: true, type: 2, message: "Message can't be empty" })
      );
      return;
    }

    let bodyFormData = new FormData();
    bodyFormData.set("text", state.reportText);
    bodyFormData.set("question_id", state?.questionData[0]?.id);

    try {
      const data = await API({
        method: "POST",
        data: bodyFormData,
        url: "report/question",
      });
      if (data.status === 200) {
        updateState({ reportText: "", modal: false });
        store.dispatch(
          setAlert({ flag: true, type: 1, message: data.data.message })
        );
      }
    } catch (error) {
      console.error("Error submitting report:", error);
      store.dispatch(
        setAlert({ flag: true, type: 2, message: "Failed to submit report" })
      );
    }
  }, [state.reportText, state.questionData]);

  const fetchQuestionByIndex = useCallback(
    async (index) => {
      const res = await loadQuestion(index);

      if (!res || res.status !== 200 || !res.data?.data?.length) {
        throw new Error("Failed to load question");
      }

      return res.data.data;
    },
    [loadQuestion]
  );


  const nextButton = useCallback(
    async (manual = false) => {
      try {

        //For testing retry functionality
        //   if (FORCE_NEXT_ERROR) {
        //   throw new Error("Forced frontend error for retry testing");
        // }
        if (state.intervalId1) {
          clearInterval(state.intervalId1);
        }

        updateState({
          option_explaination: "",
          is_answer: false,
          user_text: null,
          fail: undefined,
          new_html: null,
          new_result: null,
          submitFlag: false,
          secondCount1: 0,
          intervalId1: null,
          mainAudioPlaying: true,
          isStopped: false,
          soundStatusMain: false,
          playingAudioFromTrascriptButton: false,
          switched: false,
          nextButtonLoading: true,
          isNavigatingToNextQue: true,
          retryError: false,
          retryMessage: ""
        });

        await new Promise(resolve => setTimeout(resolve, 150));

        if (!manual && props.expVidPopup > 0) {
          nextButtonVidPopup(true);
          return;
        }

        const { currentQuestion } = state;
        // const new_ques = await loadQuestion(currentQuestion + 1);
        const resData = await fetchQuestionByIndex(currentQuestion + 1);
        console.log("resData===", resData[0]);
        const question_data = resData[0];
        // const question_data = new_ques.data.data[0];

        const {
          tag,
          tested,
          video,
          hindi_video,
          created_at,
          isVideo,
          isHindiVideo,
          attempted
        } = question_data;

        const now = new Date();
        const pastTime = new Date(created_at);
        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
        const timeDiffInMs = now.getTime() - pastTime.getTime();

        updateState({
          comment: [],
          board: [],
          history: [],
          process: false,
          currentQuestion: currentQuestion + 1,
          tag: tag.length > 0 ? tag[0].tag : "grey",
          is_answer: false,
          is_result: false,
          history_flag: false,
          comment_flag: false,
          secondCount1: 0,
          testCount: tested,
          board_flag: false,
          note_flag: false,
          viewVideo: isVideo,
          viewHindiVideo: isHindiVideo,
          videoUrl: video ?? null,
          videoHindiUrl: hindi_video ?? null,
          thirtyDaysInMs,
          timeDiffInMs,
          // questionData: new_ques.data.data,
          questionData: resData,
          soundStatusMain: true,
          attemptedTimes: attempted.length,
          nextButtonLoading: false,
          submitFlag: false,
          isStopped: false,
          isNavigatingToNextQue: false,
          audio_script: question_data.audio_script || "",
        });

        loadAttemptedQuestiondata(currentQuestion + 1);
        // moveToTopPosition();

        if (
          props.user.active_subscription.length < 1 ||
          props.user.active_subscription[0].plan.is_gold === 0
        ) {
          props.setExpVidPopup(props.expVidPopup - 1);
        }

      } catch (error) {
        console.error("Next Question Error:", error);

        updateState({
          retryError: true,
          retryIndex: state.currentQuestion + 1,
          retryType: "next",
          retryMessage: "Unable to load question. Please retry."
        });
        await fetchQuestionByIndex(currentQuestion + 1);
        store.dispatch(
          setAlert({
            flag: true,
            type: 2,
            message: "Unable to load question",
          })
        );
      } finally {
        updateState({
          nextButtonLoading: false,
          isNavigatingToNextQue: false,
        });
      }
    },
    [
      state.currentQuestion,
      state.intervalId1,
      props.user,
      props.expVidPopup,
      props.setExpVidPopup,
      loadQuestion,
      loadAttemptedQuestiondata,
      nextButtonVidPopup,
      updateState,
    ]
  );


  const nextQuestion = useCallback(() => {
    nextButton(false);
  }, [nextButton]);

  const prevButton = useCallback(
    async (e) => {
      e.preventDefault();

      try {

        //For testing retry functionality
        // if (FORCE_NEXT_ERROR) {
        //   throw new Error("Forced frontend error for retry testing");
        // }
        updateState({
          option_explaination: "",
          is_answer: false,
          user_text: null,
          fail: undefined,
          new_html: null,
          new_result: null,
          submitFlag: false,
          playingAudioFromTrascriptButton: false,
          mainAudioPlaying: true,
          soundStatusMain: false,
          switched: false,
          isStopped: false,
          prevButtonLoading: true,
          isNavigatingToNextQue: true,
          retryError: false,
          retryMessage: ""
        });

        await new Promise(resolve => setTimeout(resolve, 150));

        const { currentQuestion } = state;
        // const new_ques = await loadQuestion(currentQuestion - 1);
        // const question_data = new_ques?.data?.data?.[0];
        // Use fetchQuestionByIndex instead of loadQuestion directly
        const resData = await fetchQuestionByIndex(currentQuestion - 1);
        const question_data = resData[0];

        if (!question_data) {
          store.dispatch(
            setAlert({
              flag: true,
              type: 2,
              message: "No previous question available.",
            })
          );
          updateState({
            prevButtonLoading: false,
            isNavigatingToNextQue: false
          });
          return;
        }

        const {
          tag = [],
          tested = [],
          video = null,
          hindi_video = null,
          created_at = null,
          isVideo = false,
          isHindiVideo = false,
          attempted
        } = question_data;

        const pastTime = created_at ? new Date(created_at) : new Date();
        const now = new Date();
        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
        const timeDiffInMs = now.getTime() - pastTime.getTime();

        updateState({
          comment: [],
          board: [],
          history: [],
          process: false,
          tag: Array.isArray(tag) && tag.length > 0 ? tag[0].tag : "grey",
          currentQuestion: currentQuestion - 1,
          is_answer: false,
          is_result: false,
          history_flag: false,
          comment_flag: false,
          secondCount1: 0,
          testCount: tested,
          board_flag: false,
          note_flag: false,
          viewVideo: isVideo,
          videoUrl: video,
          viewHindiVideo: isHindiVideo,
          videoHindiUrl: hindi_video,
          thirtyDaysInMs,
          timeDiffInMs,
          questionData: resData,
          soundStatusMain: true,
          attemptedTimes: attempted.length,
          prevButtonLoading: false,
          isStopped: false,
          submitFlag: false,
          audio_script: question_data.audio_script || "",
          isNavigatingToNextQue: false
        });

        loadAttemptedQuestiondata(currentQuestion - 1);
        // moveToTopPosition();

      } catch (error) {
        console.error("Previous Question Error:", error);

        updateState({
          retryError: true,
          retryIndex: state.currentQuestion - 1,
          retryType: "prev",
          retryMessage: "Unable to load question. Please retry."
        });

        store.dispatch(
          setAlert({
            flag: true,
            type: 2,
            message: "Something Went Wrong",
          })
        );
      } finally {
        updateState({
          prevButtonLoading: false,
          isNavigatingToNextQue: false,
        });
      }
    },
    [
      state.currentQuestion,
      loadQuestion,
      loadAttemptedQuestiondata,
      updateState,
      fetchQuestionByIndex
    ]
  );
  const moveToTopPosition = () => {
    // Add this at the end of prevButton function, after the updateState call
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      const mainPanel = document.querySelector(".main-panel");
      if (mainPanel) {
        mainPanel.scrollTop = 0;
      }
    }, 200);
  };

  const submitResponse = useCallback(
    (data, f = false) => {
      const qdata = state.questionData[0];
      const obj = {
        data: data.data,
        text_answer: data.answer,
        length: data.length,
        type: qdata.subcategory_id,
        id: qdata.id,
        script: qdata.audio_script,
        q_ans: qdata.answer,
        html: qdata.html,
        correct: data.correct,
        lang: data.lang,
        duration: data.duration,
        audio_text: data.audio_text,
        answer: qdata.question,
        strategy: state.resultObj.strategy,
        blob_url: data.blob_url,
      };
      questionData[0].attempted.length

      updateState({
        resultObj: obj,
        submitFlag: f,
        new_html: null,
      });
      const isEmptyAnswer = data.answer === "" || (Array.isArray(data.answer) && data.answer.length === 0);
      const isEmptyArrayAnswer =
        data.answer === "" ||
        (Array.isArray(data.answer) &&
          data.answer.every(
            (val) => val === "" || val === undefined || val === null
          ));
      if (isEmptyArrayAnswer) {
        updateState({
          submitFlag: false,
        });
      } else if (isEmptyAnswer) {
        // console.log("data.answer && data.length == 0");
        updateState({
          submitFlag: false,
        });
      } else if (data.answer && data.answer.length == 0) {
        // console.log("data.answer && data.answer.length == 0");
        updateState({
          submitFlag: false,
        });
      }
      // console.log(state," State");
    },
    [state.questionData, state.resultObj]
  );

  const changeSelectPagination = useCallback(
    async (e) => {
      const selectedQuestion = parseInt(e.target.value);
      updateState({
        is_answer: false,
        user_text: null,
        fail: undefined,
        new_html: null,
        new_result: null,
        submitFlag: false,
        option_explaination: "",
        playingAudioFromTrascriptButton: false,
        mainAudioPlaying: true,
        soundStatusMain: false,
        switched: false,
        isNavigatingToNextQue: true
      });

      const new_ques = await loadQuestion(selectedQuestion);
      if (new_ques.status === 200) {
        const question_data = new_ques?.data?.data[0];
        const { isHindiVideo, isVideo, video, hindi_video, created_at } =
          question_data;

        const pastTime = new Date(created_at);
        const now = new Date();
        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
        const timeDiffInMs = now.getTime() - pastTime.getTime();

        updateState({
          comment: [],
          board: [],
          history: [],
          process: false,
          currentQuestion: selectedQuestion,
          tag: question_data.tag.length > 0 ? question_data.tag[0].tag : "grey",
          is_answer: false,
          is_result: false,
          history_flag: false,
          comment_flag: false,
          note_flag: false,
          secondCount1: 0,
          viewVideo: isVideo,
          videoUrl: video !== null ? video : null,
          viewHindiVideo: isHindiVideo,
          videoHindiUrl: hindi_video !== null ? hindi_video : null,
          thirtyDaysInMs,
          timeDiffInMs,
          questionData: new_ques.data.data,
          soundStatusMain: true,
          attemptedTimes: question_data.attempted.length,
          audio_script: question_data.audio_script || "",
          isNavigatingToNextQue: false
        });

        loadAttemptedQuestiondata(selectedQuestion);
        // moveToTopPosition();
      } else {
        store.dispatch(
          setAlert({
            flag: true,
            type: 2,
            message: "Something went wrong. Unable to load question.",
          })
        );
      }
    },
    [loadQuestion, loadAttemptedQuestiondata]
  );

  const submitQuestionResponse = useCallback(async (formData) => {
    const url = `submit/practice?random=${Math.floor(
      Math.random() * 1000000000
    )}`;
    const response = await API({
      method: "POST",
      url,
      data: formData,
    });

    // Refresh history data after successful submission
    if (response.status === 200) {
      updateState({ refreshHistory: true });
    }

    return response;
  }, []);

  const afterSubmitResponseActionOne = useCallback((data, state_obj) => {
    const responseData = data?.data || {};

    const content = responseData.content?.score || 0;
    const fluency = responseData.fluency?.score || 0;
    const pronunciation = responseData.pronunciation?.score || 0;
    const intonation = responseData.intonation?.score || 0;
    const new_format = responseData.new_format || null;
    const new_html = responseData.new_html || null;
    const score_data = responseData.score_data || [];
    const transcript = responseData.transcript || "";
    const html = responseData.html || "";
    const fail = responseData.fail;
    const fail_message = responseData.fail_message || "";
    const average_pace = responseData.average_pace || 0;
    const total = responseData.total || 0;
    const template_issue = responseData.template_issue;
    const common_sentence = responseData.common_sentence;
    const template_type = responseData.template_type;

    updateState((prevState) => {
      if (prevState.questionData.length === 0) {
        return prevState;
      }
      const subcategoryId = prevState.questionData[0].subcategory_id;
      if (prevState.questionData[0].subcategory_id === 5) {
        return {
          ...prevState,
          resultData: `Content Score : ${content} \n Your Response: ${transcript}`,
          new_html: new_html
            ? typeof new_html === "string"
              ? [JSON.parse(new_html)]
              : [new_html]
            : null,
          content_score: content,
          new_result: new_format || null,
          html: html,
          ...state_obj,
        };
      } else {
        const newState = {
          ...prevState,
          resultData: `Content Score : ${content} \n Fluency Score : ${fluency} \n Pronunciation Score : ${pronunciation} \n ${html}`,
          new_html: new_html
            ? typeof new_html === "string"
              ? JSON.parse(new_html)
              : new_html
            : null,
          resultPopupData: {
            content,
            fluency,
            pronunciation,
            intonation,
            average_pace,
            total,
          },
          content_score: content,
          fluency_score: fluency,
          pronunciation_score: pronunciation,
          intonation_score: intonation,
          average_pace,
          total_score: total,
          new_result: new_format || null,
          html: html,
          ...state_obj,
        };

        if ([3, 4].includes(prevState.questionData[0].subcategory_id)) {
          if (["repeat", "common"].includes(template_type)) {
            newState.explanationModal = true;
          }
          newState.score_data = score_data;
          newState.template_issue = template_issue;
          newState.common_sentence = common_sentence;
          newState.template_type = template_type;
          newState.allData = {
            content,
            fluency,
            pronunciation,
            overall: ((content + fluency + pronunciation) / 3).toFixed(0),
          };
        }

        if (fail) {
          newState.fail = fail_message;
        }

        return newState;
      }
    });
  }, []);

  const markAllMistakes = useCallback((content, mistakes) => {
    let html = content;
    return html;
  }, []);

  const findErrorIndex = useCallback((content, error, start_position) => {
    let error_index = content.indexOf(` ${error} `, start_position);
    if (error_index === -1) {
      error_index = content.indexOf(`${error} `, start_position);
    } else {
      error_index += 1;
    }
    if (error_index === -1) {
      error_index = content.indexOf(`>${error} `, start_position);
    }
    if (error_index === -1) {
      error_index = content.indexOf(` ${error}<`, start_position);
      if (error_index > -1) error_index += 1;
    }
    return error_index;
  }, []);

  const punctuationMistakeContent = useCallback((mistake) => {
    return `<span className='essay or-bg' aria-label='Punctuation error: ${mistake.correction}' data-cooltipz-dir='left' data-cooltipz-size='custom'>${mistake.error}</span>`;
  }, []);

  const replaceRange = useCallback((s, start, end, substitute) => {
    return s.substring(0, start) + substitute + s.substring(end);
  }, []);

  const markPunctuationMistakes = useCallback(
    (content, mistakes) => {
      let html = content;
      for (let i = 0; i < mistakes.length; i++) {
        const mistake = mistakes[i];
        const start_position = html.indexOf(mistake.short_context);
        const end_position =
          start_position + parseInt(mistake.short_context.length);

        let error_index = -1;
        if (mistake.error.length < 4) {
          error_index = findErrorIndex(html, mistake.error, start_position);
        } else {
          error_index = html.indexOf(mistake.error, start_position);
        }

        if (error_index >= start_position && error_index < end_position) {
          const replace_with = punctuationMistakeContent(mistake);
          html = replaceRange(
            html,
            error_index,
            error_index + mistake.error.length,
            replace_with
          );
        }
      }
      return html;
    },
    [findErrorIndex, punctuationMistakeContent, replaceRange]
  );

  const findStartPosition = useCallback((content, word) => {
    let start_position = content.indexOf(` ${word}.`);
    if (start_position === -1) start_position = content.indexOf(` ${word},`);
    if (start_position === -1) start_position = content.indexOf(` ${word};`);
    if (start_position === -1) start_position = content.indexOf(` ${word}:`);
    if (start_position === -1) start_position = content.indexOf(`>${word}`);
    if (start_position === -1) start_position = content.indexOf(`${word}<`);
    if (start_position === -1)
      start_position = content.indexOf(` ${word}<span`);
    if (start_position === -1)
      start_position = content.indexOf(`/span> ${word} `);
    return start_position;
  }, []);

  const spellingMistakeContent = useCallback((mistake) => {
    return `<span className='essay rd-bg' aria-label='Spelling mistake: ${mistake.correct}' data-cooltipz-dir='bottom' data-cooltipz-size='custom'>${mistake.word}</span>`;
  }, []);

  const markSpellingMistakes = useCallback(
    (content, mistakes) => {
      let html = content;
      for (let i = 0; i < mistakes.length; i++) {
        const mistake = mistakes[i];
        let word_to_find = ` ${mistake.word} `;
        let start_position = html.indexOf(word_to_find);

        if (start_position === -1) {
          start_position = findStartPosition(html, mistake.word);
        }

        const end_position = start_position + parseInt(word_to_find.length);
        const error_index = html.indexOf(mistake.word, start_position);

        if (error_index >= start_position && error_index < end_position) {
          const replace_with = spellingMistakeContent(mistake);
          html = replaceRange(
            html,
            error_index,
            error_index + mistake.word.length,
            replace_with
          );
        }
      }
      return html;
    },
    [findStartPosition, spellingMistakeContent, replaceRange]
  );

  const grammarMistakeContent = useCallback((mistake) => {
    return `<span className='essay bl-bg' aria-label='Grammar mistake: ${mistake.correction}' data-cooltipz-dir='top' data-cooltipz-size='custom'>${mistake.error}</span>`;
  }, []);

  const markGrammarMistakes = useCallback(
    (content, mistakes) => {
      let html = content.replace(/  +/g, " ");
      for (let i = 0; i < mistakes.length; i++) {
        const mistake = mistakes[i];
        const start_position = html.indexOf(mistake.short_context);
        const end_position =
          start_position + parseInt(mistake.short_context.length);

        let error_index = -1;
        if (mistake.error.length < 4) {
          error_index = findErrorIndex(html, mistake.error, start_position);
        } else {
          error_index = html.indexOf(mistake.error, start_position);
        }

        if (error_index >= start_position && error_index < end_position) {
          const replace_with = grammarMistakeContent(mistake);
          html = replaceRange(
            html,
            error_index,
            error_index + mistake.error.length,
            replace_with
          );
        }
      }
      return html;
    },
    [findErrorIndex, grammarMistakeContent, replaceRange]
  );

  const showVideoModal = useCallback(() => {
    if (state.videoUrl) {
      updateState({ videoModal: false, videoModalState: false });
    } else {
      updateState({ videoModalState: true, videoModal: true });
    }
  }, [state.videoUrl]);

  const ExplanationVideoModal = (type) => {
    if (type === "English") {
      updateState({ videoModalState: true, videoModal: true, videoHindiModal: false, videoHindiModalState: false });
    } else {
      updateState({ videoModalState: false, videoModal: false, videoHindiModal: true, videoHindiModalState: true });
    }
  }

  const essayResponse = useCallback((data, state_obj) => {
    const new_format = data?.data?.new_format;
    state_obj.resultData = `Result Data`;
    state_obj.new_result = new_format;
    state_obj.new_result.openai = true;
    state_obj.new_html = null;
    state_obj.new_result.html = new_format.html;
    updateState(state_obj);
  }, []);

  const essayResponseOpenAiOnly = useCallback(
    (data, state_obj) => {
      const { new_format } = data?.data || {};
      if (!new_format) {
        state_obj.resultData = `Result Data`;
        state_obj.new_result = null;
        state_obj.new_html = null;
        updateState(state_obj);
        return;
      }
      let html = new_format.html ?? "";

      html = markGrammarMistakes(html, new_format.mistakes?.grammar ?? []);
      html = markPunctuationMistakes(
        html,
        new_format.mistakes?.punctuation ?? []
      );
      html = markSpellingMistakes(html, new_format.mistakes?.spelling ?? []);

      state_obj.resultData = `Result Data`;
      state_obj.new_result = { ...new_format, html, openai: true };
      state_obj.new_html = null;
      updateState(state_obj);
    },
    [
      markGrammarMistakes,
      markPunctuationMistakes,
      markSpellingMistakes,
      updateState,
    ]
  );

  const afterSubmitResponseActionTwo = useCallback(
    (data) => {
      const {
        content_score,
        form_score,
        grammar_score,
        vocab_score,
        total_s,
        ling_score,
        struct_score,
        error,
        spelling_score,
        new_format,
      } = data.data;

      const resultData =
        state.questionData[0]?.subcategory_id === 6
          ? `Content : ${content_score}/2 
Form : ${form_score}/1 
Grammar and spellings : ${grammar_score}/2 
Vocabulary : ${vocab_score}/2 
Total : ${total_s}/7 
${error}`
          : `Content : ${content_score}/3 
Form : ${form_score}/2 
Grammar : ${grammar_score}/2 
Vocabulary : ${vocab_score}/2 
Linguistic range : ${ling_score}/2 
Structure : ${struct_score}/2 
Spelling : ${spelling_score}/2 
Total : ${total_s}/15 
${error}`;

      updateState({
        resultData,
        new_result: new_format,
        historyData: data?.data?.score_data || [],
      });
    },
    [state.questionData, updateState]
  );

  const afterSubmitResponseActionThree = useCallback(
    (data) => {
      const { score, from, new_format } = data.data;
      updateState({
        resultData: `Score : ${score}/${from}`,
        new_result: new_format,
        historyData: data?.data?.score_data || [],
      });
    },
    [updateState]
  );

  const afterSubmitResponseActionFour = useCallback(
    (data) => {
      const { new_format } = data.data;
      const subcat = state.questionData[0]?.subcategory_id;

      let resultData = "";
      if (subcat === 13) {
        const {
          content_score,
          form_score,
          grammar_score,
          vocab_score,
          spelling_score,
          total_s,
          error,
        } = data.data;
        resultData = `Content : ${content_score}/2 
Form : ${form_score}/2 
Grammar : ${grammar_score}/2 
Vocabulary : ${vocab_score}/2 
Spelling : ${spelling_score}/2 
Total : ${total_s}/10 
${error}`;
      } else if (subcat === 20) {
        const { score, from, html } = data.data;
        resultData = `Score : ${score}/${from} 
${html}`;
      } else {
        const { score, from } = data.data;
        resultData = `Score : ${score}/${from}`;
      }

      updateState({
        resultData,
        new_result: new_format,
        historyData: data?.data?.score_data || [],
      });
    },
    [state.questionData, updateState]
  );

  const getOpenAIExplaination = useCallback(async (formData) => {
    try {
      const res = await API({
        method: "POST",
        url: `submit-explanation`,
        data: formData,
      });
      updateState({ option_explaination: res.data });
    } catch (error) {
      console.error("Error fetching OpenAI explanation:", error);
    }
  }, []);

  const showResponse = useCallback(async () => {
    if (state.intervalId1) {
      clearInterval(state.intervalId1);
      updateState({ intervalId1: null });
    }
    updateState({
      is_answer: true,
      resultData: "",
      process: true,
      loader: true,
      mainAudioPlaying: false,
      new_result: null, // Reset to ensure fresh result
      attemptedTimes: state.attemptedTimes + 1,
      isStopped: false
    });

    const currentState = state;
    if (currentState.intervalId1) {
      clearInterval(currentState.intervalId1);
    }

    const { questionData, resultObj } = currentState;
    if (!questionData || questionData.length === 0 || !resultObj) {
      updateState({
        process: false,
        loader: false,
        user_text: "Invalid data, please try again",
      });
      return;
    }

    const bodyFormData = new FormData();
    bodyFormData.set("text", resultObj.answer || "");
    bodyFormData.set("script", resultObj.script || "");
    bodyFormData.set("type", resultObj.type || "");
    bodyFormData.set("id", resultObj.id || "");
    bodyFormData.set("lang", resultObj.lang || "");
    bodyFormData.set("practice", "1");
    bodyFormData.set("device", "website");

    // Add other form data based on question type
    const subcategoryId = questionData[0]?.subcategory_id;
    let responseType = 0;

    if ([1, 2, 3, 4, 5, 21, 22].includes(subcategoryId)) {
      bodyFormData.set("answer", resultObj.ans || "");
      bodyFormData.set("text_answer", resultObj.text_answer || "");
      bodyFormData.set("q_ans", resultObj.q_ans || "");
      bodyFormData.set("length", resultObj.length || "");

      // Only set file and duration if they exist and are not empty
      if (resultObj.data && resultObj.data !== "") {
        bodyFormData.set("file", resultObj.data);
      }
      if (resultObj.duration && resultObj.duration !== "") {
        bodyFormData.set("duration", resultObj.duration);
      }

      bodyFormData.set("audio_text", resultObj.audio_text || "");
      if (parseInt(subcategoryId) === 1) {
        bodyFormData.set("strategy", resultObj.strategy || "");
      }
      responseType = 1;
    } else if ([6, 7].includes(subcategoryId)) {
      bodyFormData.set("answer", resultObj.q_ans || "");
      bodyFormData.set("text_answer", resultObj.text_answer || "");
      bodyFormData.set("length", resultObj.length || "");
      responseType = 2;
    } else if ([8, 9, 10, 11, 12].includes(subcategoryId)) {
      bodyFormData.set("selected", resultObj.text_answer || "");
      bodyFormData.set("answer", resultObj.correct || "");
      bodyFormData.set("correct", resultObj.correct || "");
      responseType = 3;
    } else if ([13, 14, 15, 17, 19, 20, 18, 16].includes(subcategoryId)) {
      bodyFormData.set("text_answer", resultObj.text_answer || "");
      bodyFormData.set("answer", resultObj.correct || "");
      bodyFormData.set("selected", resultObj.text_answer || "");
      bodyFormData.set("correct", resultObj.correct || "");
      bodyFormData.set("html", resultObj.html || "");
      bodyFormData.set("ans", resultObj.q_ans || "");
      bodyFormData.set("length", resultObj.length || "");
      responseType = 4;
    }

    try {
      const data = await submitQuestionResponse(bodyFormData);
      console.log("Here is the data we got from the submit: ", data)
      if (data?.response?.status === 403 &&
        data?.response?.data?.message === "Tokens finished") {
        updateState({
          currTokens: 0,
          loader: false,
          process: false,
          is_answer: false,
          tokensPopUp: true,
        });
        return; // Exit early, don't process further
      }

      updateState({
        resultPopup: true,
        loader: false,
        process: false,
      });

      const user = data?.data?.user;
      const tokens = data?.data?.tokens;
      const questionSubCat = questionData[0]?.subcategory_id;
      const token = speaking.includes(questionSubCat)
        ? tokens?.speaking
        : writing.includes(questionSubCat)
          ? tokens?.writing
          : null;
          
          	const { score_data,speed_percentage } = data.data.data;
            console.log("speed_percentage",speed_percentage);
            console.log("data.data",data.data);
            
            setState((prevState) => ({
              ...prevState,
              speed_percentage: speed_percentage 
            }));

      if (user) {
        props.setUser(user);
        loadAttemptedQuestiondata(currentState.currentQuestion);
      }

      const state_obj = {
        loader: false,
        historyData: data?.data?.data?.score_data || [],
        process: false,
        user_text: null,
        currTokens: token,
        tokens,
      };

      // Handle different response types
      switch (responseType) {
        case 1:
          afterSubmitResponseActionOne(data?.data, state_obj);
          break;
        case 2:
          if (questionData[0]?.subcategory_id === 7) {
            essayResponse(data?.data, state_obj);
          } else {
            afterSubmitResponseActionTwo(data?.data, state_obj);
          }
          break;
        case 3:
          afterSubmitResponseActionThree(data?.data, state_obj);
          break;
        case 4:
          afterSubmitResponseActionFour(data?.data, state_obj);
          break;
        default:
          console.warn("Unhandled response type:", responseType);
          updateState({
            ...state_obj,
            new_result: data?.data?.new_format || null,
          });
      }

      // Fetch explanations for specific subcategories
      if ([11, 12].includes(parseInt(resultObj.type))) {
        getOpenAIExplaination(bodyFormData);
        if (currentState.currentQuestion <= 5 && currentState.videoUrl) {
          showVideoModal();
        }
      }
       const subcategoryId = state.questionData[0]?.subcategory_id;
       const hasValidVideoUrl = Boolean(state.videoUrl && state.videoUrl !== "null");
      const shouldAutoOpenVideo =
        data.data.data.score === 0 &&
        [10, 11, 12].includes(subcategoryId) &&
        hasValidVideoUrl;
        console.log("Subcategory : ",subcategoryId , "This is shouldAutoOpen : ",shouldAutoOpenVideo);
        if(shouldAutoOpenVideo){
          window.clearTimeout(autoOpenVideoTimeoutRef.current);
          autoOpenVideoTimeoutRef.current = window.setTimeout(() => {
             showVideoModal();
             ExplanationVideoModal("English");
           }, 2000);
        }
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 403 &&
        err?.response?.data?.message === "Tokens finished") {
        updateState({
          currTokens: 0,
          loader: false,
          process: false,
          is_answer: false,
          tokensPopUp: true,
        });
        return;
      }
      updateState({
        process: false,
        user_text: "Request failed. Try again",
        is_answer: false,
        loader: false,
      });
      store.dispatch(
        setAlert({
          flag: true,
          type: 2,
          message: "Something went wrong.",
        })
      );
    }
  }, [
    state,
    submitQuestionResponse,
    props,
    loadAttemptedQuestiondata,
    afterSubmitResponseActionOne,
  ]);

  const updateAttemptedState = () => {
    updateState({ attemptedTimes: state.attemptedTimes - 1 });
  }

  const explanationPopUp = useCallback((status) => {
    updateState({ explanationPopUp: status });
  }, []);

  const togglePopUp = useCallback((status) => {
    updateState({ tokensPopUp: status });
  }, []);

  const commonPopupToggle = useCallback(() => {
    updateState({ commonPopupIsOpen: !state.commonPopupIsOpen });
  }, [state.commonPopupIsOpen]);

  const toggleDropDown = useCallback(() => {
    updateState({ dropdownOpen: !state.dropdownOpen });
  }, [state.dropdownOpen]);

  const toggle = useCallback(
    (tab) => {
      if (state.activeTab !== tab) {
        updateState({ activeTab: tab });
      }
    },
    [state.activeTab]
  );

  const showModal = useCallback(() => {
    updateState({ modal: !state.modal, reportText: "" });
  }, [state.modal]);

  const resultStatus = useCallback(() => {
    updateState({ is_result: true });
  }, []);

  const showHistory = useCallback((e) => {
    e.preventDefault();
    updateState({
      boardMore: false,
      history_flag: true,
      note_flag: false,
      comment_flag: false,
      board_flag: false,
      history_process: false,
    });
  }, []);

  const showBoard = useCallback((e) => {
    e.preventDefault();
    updateState({
      historyMore: false,
      note_flag: false,
      history_flag: false,
      board_flag: true,
      comment_flag: false,
      board_process: false,
    });
  }, []);

  const showNotes = useCallback((e) => {
    e.preventDefault();
    updateState({
      historyMore: false,
      history_flag: false,
      board_flag: false,
      note_flag: true,
      comment_flag: false,
      board_process: false,
    });
  }, []);

  const showComment = useCallback((e) => {
    e.preventDefault();
    updateState({
      comment_flag: true,
      history_flag: false,
      board_flag: false,
      note_flag: false,
      comment_process: false,
    });
  }, []);

  const changeResponseArr = useCallback((data) => {
    updateState({ history: data });
  }, []);

  const testedFunc = useCallback(() => {
    updateState({ testModal: true });
  }, []);

  const toggleSwitch = useCallback(() => {
    updateState((prev) => ({ switched: !prev.switched }));
  }, [updateState]);

  const testedNo = useCallback(() => {
    updateState({ testModal: false });
  }, []);

  const testedYes = useCallback(async () => {
    testedNo();
    const bodyFormData = new FormData();
    bodyFormData.set("question_id", state.questionData[0].id);
    try {
      const data = await API({
        method: "POST",
        url: "tested/exam",
        data: bodyFormData,
      });
      store.dispatch(
        setAlert({ flag: true, type: 1, message: data.data.message })
      );
      updateState({ testModal: false, testCount: data.data.count });
    } catch (error) {
      console.error("Error marking tested:", error);
      updateState({ testModal: false });
    }
  }, [state.questionData]);

  const restartConfirmationToggle = useCallback(() => {
    // updateState({ confirmRestart: !state.confirmRestart });
    updateState((prev) => {
      if (prev.confirmRestartProcessing) return {};
      // moveToTopPosition();
      return {
        confirmRestartProcessing: true,
        confirmRestart: !prev.confirmRestart,
        // submitFlag:false,
        // isStopped:false
      };
    });

    setTimeout(() => {
      updateState({ confirmRestartProcessing: false });
    }, 300);
  }, [state.confirmRestart]);

  // const restartQuestion = useCallback(() => {
  //   if (state.intervalId1) {
  //     clearInterval(state.intervalId1);
  //   }

  //   updateState({
  //     restart: true,
  //     secondCount1: 0,
  //     intervalId1: null,
  //     is_result: false,
  //     is_answer: false,
  //     user_text: null,
  //     fail: undefined,
  //     new_html: null,
  //     submitFlag: false,
  //     confirmRestart: false,
  //     option_explaination: "",
  //   });
  // }, [state.intervalId1, updateState]);

  const restartQuestion = useCallback(() => {
    updateState((prev) => {
      // 🚫 Prevent multiple clicks
      if (prev.confirmRestartProcessing) return {};

      if (prev.intervalId1) {
        clearInterval(prev.intervalId1);
      }

      return {
        confirmRestartProcessing: true,
        confirmRestart: false,

        restart: true,
        secondCount1: 0,
        intervalId1: null,
        is_result: false,
        is_answer: false,
        user_text: null,
        fail: undefined,
        new_html: null,
        submitFlag: false,
        option_explaination: "",
        mainAudioPlaying: true,
        isStopped: false,
        switched: false,
        soundStatusMain: true,
        playingAudioFromTrascriptButton: false,
      };
    });

    // 🔓 unlock after state settles
    setTimeout(() => {
      updateState({ confirmRestartProcessing: false });
    }, 300);
  }, [state.intervalId1, updateState]);

  const restartQue = useCallback(() => {
    updateState({ restart: false, secondCount1: 0 });
  }, []);

  const setIsStopped = () => {
    updateState({ isStopped: false });
  };

  const changeInput = useCallback(
    async (value) => {
      setIsLoading(true);
      // updateState({
      //   loader: true,
      //   process: true
      // });
      const bodyFormData = new FormData();
      bodyFormData.set("question_id", state.questionData[0].id);
      bodyFormData.set("tag", value);
      bodyFormData.set("id", state.type);
      bodyFormData.set("prediction", state.prediction);
      bodyFormData.set("type", state.aType);
      bodyFormData.set("mark", state.mark);

      try {
        const data = await API({
          method: "POST",
          url: "set/tag",
          data: bodyFormData,
        });
        const items = [...state.questionData];
        items[0] = { ...items[0], tag: [{ tag: value }] };
        updateState({ questionData: items });
      } catch (error) {
        console.error("Error updating tag:", error);
      }
      setIsLoading(false);
      // updateState({
      //   loader: false,
      //   process: false
      // });
    },
    [state.questionData, state.type, state.prediction, state.aType, state.mark]
  );

  const soundChecked = useCallback(() => { }, []);

  const stopRecording = useCallback(() => { }, []);

  const setStrategy = useCallback(
    (st) => {
      updateState({ resultObj: { ...state.resultObj, strategy: st } });
    },
    [state.resultObj]
  );

  const renderResponse = useCallback(
    (items) => {
      return (
        <>
          {items.map((item, i) => {
            if (state.questionData[0].subcategory_id === 5) {
              return (
                <>
                  <span>Your Response: </span>
                  <span className={item.class} key={i}>
                    {item.word !== "&nbsp;" ? item.word : " "}
                  </span>
                </>
              );
            } else {
              return <TooltipItem key={i} item={item} id={i} />;
            }
          })}
        </>
      );
    },
    [state.questionData]
  );

  const setRestart = useCallback(() => {
    updateState({ restart: false, secondCount: 0 });
  }, []);

  const selectScriptLanguage = useCallback(
    async (selectedValue) => {
      if (selectedValue !== "English" && selectedValue !== "0") {
        updateState({ audio_script: "Translating text. Please wait..." });
        try {
          const res = await API({
            url: "translate/sentence",
            method: "POST",
            data: {
              script: state.questionData[0].audio_script,
              lang: selectedValue,
              question_id: state.questionData[0].id,
            },
          });
          updateState({
            currentScriptLanguage: selectedValue,
            audio_script:
              typeof res.data.translation === "object"
                ? res.data.translation.translation
                : res.data.translation,
          });
        } catch (error) {
          console.error("Error translating script:", error);
        }
      } else {
        updateState({
          currentScriptLanguage: "English",
          audio_script: state.questionData[0].audio_script,
        });
      }
    },
    [state.questionData]
  );

  const wordDefinitionModalToggle = useCallback((status) => {
    if (status) {
      updateState({ modalDestroy: false, wordDefinitionModalIsOpen: status });
    } else {
      updateState({ wordDefinitionModalIsOpen: status });
      setTimeout(() => {
        updateState({ modalDestroy: true, selectedWord: "" });
      }, 1000);
    }
  }, []);

  const selectWord = useCallback(
    (item) => {
      wordDefinitionModalToggle(true);
      updateState({ selectedWord: item });
    },
    [wordDefinitionModalToggle]
  );

  const translatePopup = useCallback((status) => {
    updateState({ shadowingPopup: status, translateModal: status });
  }, []);

  const sampleResponseAudioPopup = useCallback((status) => {
    updateState({ shadowingPopup: status, sampleResponseModal: status });
  }, []);

  const filterScript = useCallback((question) => {
    let script = "";
    const q = question.split("__add_blank__");
    q.forEach((item, i) => {
      if (i === 0) {
        script += item;
      } else {
        let raw = item;
        item = item.replace("<span id='cAns'>", "");
        const word = item.split("</span>")[0];
        item = item.replace(`${word}</span>`, word);
        script += item;
      }
    });
    return script;
  }, []);

  const questionScript = useCallback(() => {
    const { questionData } = state;
    let script = "";
    switch (questionData[0]?.subcategory_id) {
      case 1:
        script = questionData[0].question;
        break;
      case 2:
      case 4:
      case 13:
      case 16:
        script = questionData[0].audio_script;
        break;
      case 11:
        script = filterScript(questionData[0].question);
        break;
      default:
        break;
    }
    return script;
  }, [state.questionData, filterScript]);

  const buttonLabel = useCallback((subcategory_id) => {
    return subcategory_id === 1 ? "Sample Response" : "Hearing Mode";
  }, []);

  const setCorrectClassName = useCallback(() => {
    const subcategory_id = parseInt(state.type);
    if ([8, 9].includes(subcategory_id)) return "reading-section";
    if ([10].includes(subcategory_id)) return "re-order-section";
    if ([13].includes(subcategory_id)) return "write-essay-wrapper";
    if ([16].includes(subcategory_id)) return "lf-blank";
    return "";
  }, [state.type]);

  const toggleResultPopup = useCallback(() => {
    updateState({ resultPopup: !state.resultPopup });
  }, [state.resultPopup]);

  const writeEssayAiSuggestions = useCallback((question) => {
    return question !== undefined && parseInt(question.subcategory_id) === 7;
  }, []);

  const updateCurrentQuestion = useCallback((current_question) => {
    updateState({ currentQuestion: current_question });
  }, []);

  const updateAudioFinishedFromTranscript = useCallback((status) => {
    console.log("I am transcript  play button and here is the state");
    console.log("Playing audio state", playingAudioFromTrascriptButton);
    console.log("And this is the state coming in Status", status);
    updateState({ playingAudioFromTrascriptButton: status });
  }, []);

  const updateQuestionAudioUrl = useCallback((url) => {
    updateState({ questionAudioUrl: url });
  }, []);

  const openModalExplanation = useCallback(() => {
    const { new_result, template_issue, template_type } = state;
    if (
      new_result !== null &&
      ((template_issue && template_issue.trim() !== "") ||
        ["common", "repeat"].includes(template_type))
    ) {
      updateState({ explanationModal: true });
    }
  }, [state.new_result, state.template_issue, state.template_type]);

  const closeModalExplanation = useCallback(() => {
    updateState({ explanationModal: false });
  }, []);

  const uniqueInstruction = useCallback((title) => {
    return `You will hear a recording about ${title}. At the end of the recording the last word or group of words has been replaced by a beep. Select the correct option to complete the recording`;
  }, []);

  const showExplanation = useCallback(() => {
    updateState({ paragraphExplainationModal: true });
  }, []);

  const toggleModal = useCallback(() => {
    updateState({
      paragraphExplainationModal: false,
    });
  }, [state.paragraphExplainationModal]);

  const closeVideoModal = useCallback(() => {
    updateState({
      videoHindiModal: false,
      videoHindiModalState: false,
      videoModal: false,
      videoModalState: false, // ✅ Reset both states
    });
  }, [updateState]);

  const changeAnswer = useCallback(
    (data) => {
      updateState({
        resultObj: {
          ...state.resultObj,
          text_answer: data,
        },
      });
    },
    [state.resultObj, updateState]
  );

  let ques_title = "";
  let topBar = false;

  const {
    questionData,
    currentQuestion,
    type,
    all_ok,
    modal,
    reportText,
    testModal,
    videoModal,
    videoModalState,
    videoUrl,
    videoHindiModal,
    videoHindiModalState,
    videoHindiUrl,
    is_answer,
    tag,
    timeDiffInMs,
    thirtyDaysInMs,
    isAttempted,
    secondCount1,
    hideNav,
    total_questions,
    isBlocked,
    resultData,
    historyData,
    resultId,
    switched,
    isSubscribed,
    user,
    submitFlag,
    viewVideo,
    viewHindiVideo,
    testCount,
    comment_flag,
    // isSubscribedCheck,
    history_flag,
    board_flag,
    note_flag,
    open_ques,
    restart,
    user_text,
    fail,
    content_score,
    pronunciation_score,
    fluency_score,
    intonation_score,
    average_pace,
    total_score,
    writing_result,
    new_result,
    option_explaination,
    resultObj,
    template_type,
    template_issue,
    common_sentence,
    score_data,
    no_of_repeat_allowed,
    allData,
    showBottomExplanationPopup,
    tokensPopUp,
    scriptLanguages,
    voices,
    shadowingPopup,
    playingAudioFromTrascriptButton,
    questionAudioUrl,
    nextBtnVid,
    expVid,
    loader,
    wordDefinitionModalIsOpen,
    selectedWord,
    translateModal,
    sampleResponseModal,
    dropdownOpen,
    resultPopup,
    confirmRestart,
    currTokens,
    paragraphExplainationModal,
    explanationModal,
    new_html,
    isStopped
  } = state;

  const templateDetectorModalProps = {
    title:
      template_type === "repeat"
        ? template_issue
        : template_type === "common"
          ? common_sentence
          : "",
    template_type: template_type,
    common_sentence: common_sentence,
    data: {
      remarks: score_data[0]?.remarks,
      no_of_repeat_allowed: no_of_repeat_allowed,
      overallScore: allData?.pronunciation,
      contentScore: allData?.content,
      fluencyScore: allData?.fluency,
      pronunciationScore: allData?.pronunciation,
    },
  };

  const retryQuestion = async () => {
    try {
      //    if (FORCE_NEXT_ERROR) {
      //   throw new Error("Forced frontend error for retry testing");
      // }
      updateState({
        retryError: false,
        questionData: [],
        [state.retryType === 'next' ? 'nextButtonLoading' : 'prevButtonLoading']: true
      });

      const data = await fetchQuestionByIndex(state.retryIndex);

      updateState({
        questionData: data,
        currentQuestion: state.retryIndex,
        [state.retryType === 'next' ? 'nextButtonLoading' : 'prevButtonLoading']: false
      });

      loadAttemptedQuestiondata(state.retryIndex);
      // moveToTopPosition();

    } catch (err) {
      updateState({
        retryError: true
      })
      store.dispatch(
        setAlert({
          flag: true,
          type: 2,
          message: "Retry failed. Please check your connection."
        })
      );
      updateState({
        nextButtonLoading: false,
        prevButtonLoading: false
      });
    }
  };

  const queProps = {
    restart: state.restart,
    restartQue: () => updateState({ restart: false, secondCount1: 0 }),
    submit: submitResponse,
    showResult: () => updateState({ is_result: true }),
    data:
      state?.questionData && state?.questionData.length > 0
        ? state?.questionData[0]
        : null,
    func: changeAnswer,
    answer: state.is_answer,
    resultMode: false,
    testCount: 0,
    tag: "grey",
    testMode: false,
    resultId: false,
    soundChecked: () => { },
    stopRecording: () => { },
    user_text: state.user_text,
    strategy: state.resultObj.strategy,
    setStrategy,
    setRestart: () => updateState({ restart: false, secondCount: 0 }),
    scriptLanguages: state.scriptLanguages,
    voices: state.voices,
    shadowingPopup: state.shadowingPopup,
    total_questions: state.total_questions,
    currentQuestion: state.currentQuestion,
    showResponse,
    updateQuestionAudioUrlInPractice: updateQuestionAudioUrl,
    nextQuestion,
    soundStatusMain: state.soundStatusMain,
    onMainAudioFinished: () => {
      updateState({ mainAudioPlaying: false })
    },
    setIsStopped,
    isStopped: state.isStopped
  };

  if (questionData.length > 0) {
    ques_title = questionData[0].q_title;
  }

  const title =
    parseInt(type) !== 18
      ? QuestionInstructions[parseInt(type)]
      : uniqueInstruction(ques_title);

  // // Show loading state while data is being fetched
  // if (state.loading) {
  //   return <LoaderDumb />;
  // }



  const que = (
    state.retryError === true ? (
      <div className="retry-container d-flex flex-column align-items-center justify-content-center">
        <p className="error-text">{state.retryMessage}</p>
        <button
          className="outline-btn"
          onClick={() => retryQuestion()}
        >
          Retry
        </button>
      </div>
    ) : questionData.length > 0 && state.isNavigatingToNextQue === false ? (
      <LoadQuestionType
        queProps={queProps}
        subcategoryId={parseInt(type)}
        languages={scriptLanguages}
        option_explaination={option_explaination}
        key={restart || currentQuestion}
        submitDisable={is_answer || !submitFlag}
      />
    ) : (
      <div className="pmw-tabs-section pmw-outer-wrapper m-0 loading-wrapper">
        <div className="question-skeleton">
          <Spinner id="mocklist-spinner-question" />
        </div>
      </div>
    ))

  let content_class_name = "";
  if (content_score !== undefined) {
    if (parseInt(type) !== 5) {
      content_class_name =
        content_score.score <= 30
          ? "text-danger"
          : content_score.score > 30 && content_score.score <= 70
            ? "text-orange"
            : "text-success";
    } else {
      content_class_name =
        content_score.score < 1 ? "text-danger" : "text-success";
    }
  }

  let speak_result_show = false;
  let write_result_show = false;
  let reading_result_show = false;
  let listening_result_show = false;
  let write_from_dictation_result_show = false;

  if ([1, 2, 3, 4, 5, 21, 22].includes(parseInt(type))) {
    speak_result_show = new_result !== null ? true : false;
  }

  if ([6, 7, 13].includes(parseInt(type))) {
    write_result_show = new_result !== null ? true : false; // Simplified redundant condition
  }

  if ([8, 9, 10, 11, 12, 16].includes(parseInt(type)) && new_result !== null) {
    reading_result_show = true;
  }

  if ([14, 15, 17, 18, 19].includes(parseInt(type)) && new_result !== null) {
    listening_result_show = true;
  }

  if ([20].includes(parseInt(type))) {
    write_from_dictation_result_show = true;
  }

  // showParagraphExplanationButton = () => {
  //   if ([11, 12].includes(parseInt(type))) {
  //     let question = questionData[currentQuestion];
  //     if ('explanation' in question && 'paragraph_explanation' in question.explanation) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  useEffect(() => {
    // Add document class
    // document.body.classList.add("leftSidebarClosed");

    let localStorage_orderby = localStorage.getItem("orderby");
    if (!localStorage_orderby) {
      localStorage.setItem("orderby", "desc");
    }

    let hideNav = parseInt(viewParam) === 1 ? true : false;
    let open_ques = parseInt(pageParam) ? parseInt(pageParam) : 0;
    let q_id = params?.index;
    let item_number = parseInt(itemNumberParam) ? parseInt(itemNumberParam) : 1;

    updateState({ hideNav, open_ques });

    const loadAndSetQuestion = async () => {
      try {
        const ques = await loadQuestion(item_number, q_id);
        if (ques.status === 200) {
          const expVid = ques.data.expVid;
          const intervalId1 = setInterval(timer1, 1000);
          const question_data = ques.data.data[0];

          const token = speaking.includes(question_data.subcategory_id)
            ? ques.data.tokens?.speaking
            : writing.includes(question_data.subcategory_id)
              ? ques.data.tokens?.writing
              : null;

          updateState({
            currTokens: token,
            questionData: ques.data?.data || [],
            tokens: ques.data?.tokens || [],
            tag:
              question_data.tag.length > 0 ? question_data.tag[0].tag : "grey",
            intervalId1,
            currentQuestion: item_number,
            total_questions: ques.data.total || 0,
            testCount: ques.data.data[0].tested || 0,
            expVid,
            scriptLanguages: ques.data.script_languages || [],
            audio_script: ques.data.data[0].audio_script || "",
            voices: ques.data.voices || [],
            loading: false,
            attemptedTimes: question_data.attempted.length,
            mainAudioPlaying: true
          });

          setTimeout(() => {
            setStartFeaturesTour(true);
          }, 1000);

          // Handle video and timing logic
          const { video, hindi_video, created_at, isVideo, isHindiVideo } =
            question_data;
          console.log("VIDEO : ", video, question_data, state);

          const pastTime = new Date(created_at);
          const now = new Date();
          const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
          const timeDiffInMs = now.getTime() - pastTime.getTime();

          const currentUser = props.user;
          let attempted_questions = [];
          if (
            currentUser.user_attempted_questions !== null &&
            currentUser.user_attempted_questions !== undefined
          ) {
            attempted_questions =
              currentUser.user_attempted_questions.attempted_questions;
          }
          const obj =
            attempted_questions.length > 0
              ? JSON.parse(attempted_questions)
              : attempted_questions;
          const questions_id = obj.questions_id || [];

          updateState({
            videoUrl: video !== null ? video : null,
            viewVideo: isVideo,
            videoHindiUrl: hindi_video !== null ? hindi_video : null,
            viewHindiVideo: isHindiVideo,
            thirtyDaysInMs,
            timeDiffInMs,
            attemptedQuestions: questions_id,
          });

          // Load attempted question data
          loadAttemptedQuestiondata(item_number);
        }
      } catch (error) {
        console.error("Error loading question:", error);
        updateState({
          retryError: true,
          loading: false,
          error: "Error loading question data.",
        });
      }
    };

    stayConnected();
    loadAndSetQuestion();
  }, []);

  useEffect(() => {
    return () => {
      cleanupAllTours();
    };
  }, []);

  useEffect(() => {
    return () => {
      // document.body.classList.remove("leftSidebarClosed");
      if (state.intervalId1) {
        clearInterval(state.intervalId1);
      }
      if (state.ping_server) {
        clearInterval(state.ping_server);
      }
    };
  }, [state.intervalId1, state.ping_server]);

  // Load attempted question data after questionData or currentQuestion changes
  // useEffect(() => {
  //   if (state.questionData.length > 0 && state.currentQuestion !== undefined) {
  //     loadAttemptedQuestiondata(state.currentQuestion);
  //   }
  // }, [state.questionData, state.currentQuestion]);

  useEffect(() => {
    if (props.expVidPopup === 10 && !state.nextBtnVid) {
      nextButton(true);
    }
  }, [props.expVidPopup, state.nextBtnVid, nextButton]);

  if (state.loading) {
    return <LoaderDumb show={true} />;
  }

  // if (state.error) {
  //   return (
  //     <div className="error-container">
  //       <p>Error: {state.error}</p>
  //       <button onClick={() => window.location.reload()}>Retry</button>
  //     </div>
  //   );
  // }

  // if (questionData.length === 0 && !state.loading) {
  //   return (
  //     <div>No question data available. Please try refreshing the page.</div>
  //   );
  // }

  return (
    <>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>

      {/* {!all_ok && <ChromeCheck />} */}

      {!state.connected && (
        <div className="connectivity-container">
          <div className="bg-danger text-light not-connected text-center p-1">
            Seems like you are not connected to our server. Please try reloading
            the page or check your connection. &nbsp;{" "}
            <button className="btn-success btn-sm">Connect</button>
          </div>
        </div>
      )}

      {state.connected && state.backOnline && (
        <div className="connectivity-container">
          <div className="bg-success text-light not-connected text-center p-1">
            <b>Connection restored. Please continue with your tasks.</b>
          </div>
        </div>
      )}

      {all_ok && questionData.length > 0 && (
        <>
          {questionAudioUrl && (
            <QuestionAudioAlternative
              question_audio={questionAudioUrl}
              play={playingAudioFromTrascriptButton}
              updateAudioFinishedFromTranscript={
                updateAudioFinishedFromTranscript
              }
              refreshHistory={state.refreshHistory}
            />
          )}

          {resultPopup && SHOW_RESULT_POPUP.includes(parseInt(type)) && (
            <ResultPopup
              question_id={questionData[0].id}
              isAnswer={is_answer}
              resultData={resultData}
              speakingResult={speak_result_show}
              writingResult={write_result_show}
              readingResult={reading_result_show}
              listeningResult={listening_result_show}
              writeFromDictationResult={write_from_dictation_result_show}
              fail={fail}
              newResult={new_result}
              newHtml={new_html}
              subcategoryId={parseInt(type)}
              renderResponse={renderResponse}
              correctAnswer={questionData[0].answer}
              option_explaination={option_explaination}
              historyData={historyData}
              toggleResultPopup={toggleResultPopup}
              isPopup={false}
              question_title={questionData[0].q_title}
              recorded_file={resultObj.blob_url}
              question={questionData[0]}
              script={state.audio_script}
              template_issue={template_issue}
              template_type={template_type}
              common_sentence={common_sentence}
              score={questionData[0]?.score || 0}
              explanationModal={explanationModal}
              templateDetectorModalProps={templateDetectorModalProps}
              closeModalExplanation={closeModalExplanation}
              html={state.html}
              speed_percentage={state.speed_percentage}
            />
          )}

          <ConfirmAction
            title="Restart Question?"
            message="Are you sure to restart this question?"
            yesLabel="Yes, Please restart"
            noLabel="No, I don't want to restart"
            status={confirmRestart}
            toggle={restartConfirmationToggle}
            confirm={restartQuestion}
            processing={state.confirmRestartProcessing}
          />

          <div className="siteContent p-0">
            <DashboardHeader title="Practice Material" />

            <div className={`pmw ${setCorrectClassName()}`}>
              <div className="dashboard-content-wrapper read-aloud-wrapper mb-12 new-dash">
                <PracticePageHeader
                  questionData={questionData[0]}
                  isAttempted={isAttempted}
                  TAGS={TAGS}
                  toggle={toggleDropDown}
                  isOpen={dropdownOpen}
                  changeHandler={changeInput}
                  time={state?.secondCount1}
                  subcategoryId={type}
                  title={title}
                  strategyVideo={explanationPopUp}
                  isLoading={isLoading}
                  retryError={state.retryError}
                  videoURL={expVid}
                />
              </div>

              {type === "21" && (
                <div className="m-0 m-lg-0 pt-2 question-area-main">
                  <div className="pmw-outer-wrapper gray-text">
                    {questionData[0]?.audio_script}
                  </div>
                </div>
              )}

              <div className="question-area-main m-0 m-md-4  d-grid d-md-block pb-2 pb-md-0">
                {questionData.length > 0 ? que : <div>Loading question...</div>}
              </div>

              {!SHOW_RESULT_POPUP.includes(parseInt(type)) && (
                <Result
                  isAnswer={is_answer}
                  resultData={resultData}
                  speakingResult={speak_result_show}
                  writingResult={write_result_show}
                  readingResult={reading_result_show}
                  listeningResult={listening_result_show}
                  writeFromDictationResult={write_from_dictation_result_show}
                  fail={fail}
                  newResult={new_result}
                  newHtml={new_html}
                  subcategoryId={parseInt(type)}
                  renderResponse={renderResponse}
                  correctAnswer={questionData[0].answer}
                  historyData={historyData}
                  question={questionData[0]}
                  showExplanation={showExplanation}
                  script={state.audio_script}
                  
                />
              )}

              <div className="pmw-outer-wrapper audio-transcript-wrapper">
                <div className="d-block d-md-flex align-items-center justify-content-between flex-wrap lg:flex-wrap">
                  <div className="left-btns audio-transcript-content">
                    <button
                      // href="javascript:void(0)"
                      className="outline-btn restartbtn"
                      onClick={restartConfirmationToggle}
                    >
                      Restart
                    </button>
                    <button
                      // href="javascript:void(0)"
                      className="submit-btns"
                      onClick={showResponse}
                      disabled={(is_answer || !submitFlag) && !isStopped}
                    >
                      Submit
                    </button>
                    {/* {([10, 11, 12].includes(parseInt(type)) && state.videoUrl) && (
                      <>
                        <div className="right-btns">
                          <button
                            className="ml-3 outline-btn"
                            onClick={() => ExplanationVideoModal("English")}
                          >
                            Explanation (English)
                          </button>
                        </div>
                        <br />
                      </>
                    )}
                     {([11, 12].includes(parseInt(type)) && state.viewHindiVideo) && (
                      <>
                        <div className="right-btns">
                          <button
                            className="ml-3 outline-btn"
                            onClick={() => ExplanationVideoModal("Hindi")}
                          >
                            Explanation (Hindi)
                          </button>
                        </div>
                        <br />
                      </>
                    )} */}
                    {AUDIO_TRANSCRIPT.includes(
                      questionData[0].subcategory_id
                    ) && (
                      <>
                        <span className="audio_script_button position-relative">
                          Audio Transcript:{" "}
                          <span className="info-icon-wrapper">
                          <i className="bi bi-info-circle-fill info-icon"></i>

                          <span className="custom-tooltip">
                          {/* {getComplexity("tooltip", questionData.complexity)} */}
                          Audio transcripts are available in Practice mode only and will not appear in Mock Tests.
                          </span>
                        </span>
                          {/* <Switch
                            onText="Show"
                            offText="Hide"
                            onChange={toggleSwitch}
                            on={switched}
                            value={switched}
                          /> */}
                        </span>
                          <Form.Check
                            type="switch"
                            id="audio-transcript-switch"
                            className={`no-switch-padding ${state.retryError ? "disabled" : ""}`}
                            checked={switched}
                            disabled={state.retryError}
                            onChange={(e) => toggleSwitch(e.target.checked)}
                          />
                      </>
                      )}

                    {/* {writeEssayAiSuggestions(questionData[0]) && (
                      <MoreAiSuggestions question_id={questionData[0].id} />
                    )} */}

                    {SHOW_RESULT_POPUP.includes(parseInt(type)) &&
                      is_answer && (
                        <button
                          className="submit-btns"
                          onClick={toggleResultPopup}
                        >
                          See Result
                        </button>
                      )}
                  </div>
                  <div className="right-btns d-flex justify-content-center">
                    {/* <Form.Select
                      onChange={changeSelectPagination}
                      value={currentQuestion}
                      className="badge-dropdown"
                    >
                      {Array.from(Array(total_questions), (e, i) => {
                        const item = i + 1;
                        return (
                          <option key={i} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </Form.Select> */}

                    <InfiniteQuestionDropdown
                      total={total_questions}
                      value={currentQuestion}
                      onChange={changeSelectPagination}
                    />

                    <div className="d-flex">
                      <button
                        onClick={currentQuestion === 1 ? undefined : prevButton}
                        disabled={currentQuestion === 1 || state.prevButtonLoading}
                        className={`prev-next-btn ${currentQuestion === 1 || state.prevButtonLoading || state.nextButtonLoading ? "disabled" : ""
                          }`}
                      >
                        {state.prevButtonLoading ? "Loading..." : "Previous"}
                      </button>
                      <button
                        onClick={() => nextButton(false)}
                        disabled={currentQuestion === total_questions || state.nextButtonLoading}
                        className={`prev-next-btn ${currentQuestion === total_questions || state.nextButtonLoading || state.prevButtonLoading ? "disabled" : ""
                          }`}
                      >
                        {state.nextButtonLoading ? "Loading..." : "Next"}
                      </button>
                    </div>
                  </div>
                </div>

                {switched && (
                  <div className="audio-transcript-text visibility-visible line-height-adjust">
                    {questionData[0].audio_script !== null &&
                      questionData[0].audio_script.split(" ").map((item, i) => (
                        <React.Fragment key={i}>
                          <span
                            className="word cursor-pointer"
                            onClick={() => selectWord(item)}
                          >
                            {item}
                          </span>
                          <i> </i>
                        </React.Fragment>
                      ))}
                    {/* <span
                      className="outline-btn cursor-pointer"
                      onClick={() =>
                        updateAudioFinishedFromTranscript(
                          !playingAudioFromTrascriptButton
                        )
                      }
                    > */}
                    <button
                      className={`audio-btn ${state.mainAudioPlaying ? 'disabled' : ''}`}
                      onClick={() => {
                        if (!state.mainAudioPlaying) {
                          updateAudioFinishedFromTranscript(!playingAudioFromTrascriptButton);
                        }
                      }}
                      style={{ opacity: state.mainAudioPlaying ? 0.5 : 1, cursor: state.mainAudioPlaying ? 'not-allowed' : 'pointer' }}
                    >
                      {!playingAudioFromTrascriptButton ? (
                        <i className="fa fa-play"></i>
                      ) : (
                        <i className="fa fa-stop"></i>
                      )}
                    </button>
                    {parseInt(type) === 5 && (
                      <div>
                        Correct Answer:{" "}
                        <span className="correct-answer">
                          {questionData[0].answer}
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="pmw-outline-btns pmw-outer-wrapper d-flex align-items-center justify-content-between">
                <div className="d-flex justify-content-md-center w_100 ">
                  {TRANSLATE_BUTTON_SUBCATEGORIES.includes(
                    questionData[0].subcategory_id
                  ) && (
                      <button
                        onClick={() => translatePopup(true)}
                        disabled={state.retryError}
                        style={{ marginRight: "10px" }}
                        className={`outline-btn-new translate-btn ${state.retryError ? "disabled" : ""
                          }`}
                      >
                        <span>
                        Translate
                        </span>
                        <img src={TranslateIcon} alt="Translate" />
                      </button>
                    )}
                  {SAMPLE_RESPONSE_BUTTON_SUBCATEGORIES.includes(
                    questionData[0].subcategory_id
                  ) &&
                    ![11, 12].includes(questionData[0].subcategory_id) && (
                      <button
                        disabled={state.retryError}
                        className={`outline-btn-new sample-btn ${state.retryError ? "disabled" : ""
                          }`}
                        onClick={() => sampleResponseAudioPopup(true)}
                      >
                        <span>
                          {buttonLabel(questionData[0].subcategory_id)}
                          </span>
                          <img src={SampleIcon} alt="sample-response" />
                      </button>
                    )}
                  {writeEssayAiSuggestions(questionData[0]) && (
                    <MoreAiSuggestions question_id={questionData[0].id} />
                  )}
                  {([10, 11, 12].includes(parseInt(type)) && state.videoUrl) && (
                    <>
                      <div className="right-btns">
                        {/* <a
                            href="javascript:void(0)"
                            className="outline-btn me-md-2"
                            onClick={showExplanation}
                          >
                            Full Paragraph Explanation
                          </a> */}
                        {/* <button
                            className="outline-btn me-md-2"
                            onClick={showExplanation}
                          >
                            Full Paragraph Explanation{type}
                          </button> */}
                        <button
                          className="ml-3 outline-btn-new explanation-btn"
                          onClick={() => ExplanationVideoModal("English")}
                        >
                          {/* Explanation (English) */}
                          <span className="exp-full">Explanation</span>
                          <span className="exp-short">Exp.</span>
                          <span className="exp-lang"> (English)</span>
                          <img src={ExplanationIcon} alt="Explanation" />
                        </button>
                      </div>
                      <br />
                    </>
                  )}
                  {([11, 12].includes(parseInt(type)) && state.viewHindiVideo) && (
                    <>
                      <div className="right-btns">
                        {/* <button
                            className="outline-btn me-md-2"
                            onClick={showExplanation}
                          >
                            Full Paragraph Explanation{type}
                          </button> */}
                        <button
                          className="ml-3 outline-btn-new explanation-btn"
                          onClick={() => ExplanationVideoModal("Hindi")}
                        >
                          {/* Explanation (Hindi) */}
                          <span className="exp-full">Explanation</span>
                          <span className="exp-short">Exp.</span>
                          <span className="exp-lang"> (Hindi)</span>
                          <img src={ExplanationIcon} alt="Explanation" />
                        </button>
                      </div>
                      <br />
                    </>
                  )}
                </div>

                <div className="outline-right-btns">
                  <button
                    id="practice-attempted-count"
                    disabled={state.retryError}
                    className={`outline-btn ${state.retryError ? "disabled" : ""
                      }`} style={{ cursor: 'default' }}>
                    {state.attemptedTimes} X Attempted
                  </button>
                  {/* <button disabled={state.retryError}
                    className={`outline-btn m-0 mx-md-2 ${state.retryError ? "disabled" : ""
                      }`} onClick={testedFunc}>
                    {testCount} X Tested </button> */}
                  {questionData.length > 0 &&
                    currTokens !== null &&
                    currTokens > -1 && (
                      <span
                        className="outline-btn"
                        style={{ padding: "6px 16px", marginRight: 8 }}
                      >
                        <img
                          width="25"
                          className="mr-2 mb-1"
                          src="/images/ai.svg"
                          alt=""
                        />
                        {" "}AI Score X {currTokens}
                      </span>
                    )}
                  <button
                    id="practice-report-btn"
                    disabled={state.retryError}
                    className={`outline-btn ${state.retryError ? "disabled" : ""
                      }`}
                    onClick={showModal}
                  >
                    Report
                  </button>
                </div>
              </div>

              {questionData.length !== 0 && !state.retryError && (
                <QuestionResponses
                  loadMyData={showHistory}
                  loadOthersData={showBoard}
                  questionData={questionData[0]}
                  key={restart || currentQuestion}
                  updateAttemptedState={updateAttemptedState}
                  refreshHistory={state.refreshHistory}
                />
              )}
            </div>

            <ExplanationPopUp
              status={nextBtnVid}
              toggle={nextButtonVidPopup}
              isSubscribed={isSubscribed}
              expVid={expVid}
            />

            {showBottomExplanationPopup && (
              <ModalSkeleton
                status={showBottomExplanationPopup}
                toggle={() =>
                  updateState({ showBottomExplanationPopup: false })
                }
                handleClick={() => navigate("/admin/sub/payment/form/37")}
                btnText="Buy Plan"
                message="Please subscribe to our gold plan to see Explanation Video"
                isSmall={false}
              />
            )}

            {translateModal && (
              <TranslateModal
                isOpen={shadowingPopup}
                toggle={translatePopup}
                question={questionScript()}
                languages={scriptLanguages}
                question_id={questionData[0].id}
                voices={voices}
              />
            )}

            {sampleResponseModal && (
              <ListenAudio
                isOpen={shadowingPopup}
                toggle={sampleResponseAudioPopup}
                question={questionScript()}
                question_id={questionData[0].id}
                voices={voices}
                audios={questionData[0].question_audios}
                subcategory_id={questionData[0].subcategory_id}
              />
            )}

            {state.explanationPopUp && (
              <ExplanationVidPopUp
                status={state.explanationPopUp}
                toggle={explanationPopUp}
                isSubscribed={isSubscribed}
                expVid={expVid}
              />
            )}

            {wordDefinitionModalIsOpen && (
              <WordDefinitionModal
                isOpen={wordDefinitionModalIsOpen}
                toggle={wordDefinitionModalToggle}
                word={selectedWord}
                languages={scriptLanguages}
              />
            )}

            {tokensPopUp && (
              <TokenFinished isOpen={tokensPopUp} toggle={togglePopUp} />
            )}

            <LoaderDumb show={!loader} />

            {modal && (
              <ReportPopup
                isOpen={modal}
                toggle={showModal}
                submit={submitReport}
                changeHandler={changeReportText}
                reportText={reportText}
              />
            )}

            {testModal && (
              <TestedPopup
                isOpen={testModal}
                toggle={testedNo}
                testedYes={testedYes}
              />
            )}
          </div>

          {(videoModal || videoHindiModal) && (
            <QuestionExplanationVideo
              isOpen={videoModalState || videoHindiModal}
              toggle={closeVideoModal}
              videoUrl={videoModal ? videoUrl : videoHindiUrl}
            />
          )}

          {paragraphExplainationModal && (
            <FillInTheBlankExplanation
              isOpen={paragraphExplainationModal}
              title="Paragraph Explanation"
              data={
                option_explaination
                  ? option_explaination.paragraph_explanation
                  : "Fetching Explanation..."
              }
              keyName="paragraph_explanation"
              closeModal={toggleModal}
            />
          )}

           <PracticeQuestionFeaturesTour 
        autoStart={startFeaturesTour && !state.loading && questionData.length > 0} 
        onComplete={() => {
          console.log('Practice question features tour completed!');
          setStartFeaturesTour(false);
        }} 
      />
        </>
      )}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Practice);
